import { StringDict } from '@azure/msal-common';
import { useMsal } from '@azure/msal-react';

export default function useEmail(): string {
  const { accounts } = useMsal();
  const currentIdToken = accounts[0].idTokenClaims! as StringDict;

  return currentIdToken?.emails[0];
}
